import { useState, useEffect } from "react";
import { MoonLoader } from "react-spinners";
import styled from "styled-components";

export default function PDFViewer({ 
    link 
}: {
    link: string;
}) {

    const [isLoaded, setIsLoaded] = useState(false);
    const [showPDF, setShowPDF] = useState(false);

    useEffect(() => {
        if (isLoaded) {
            const timer = setTimeout(() => setShowPDF(true), 1000);
            return () => clearTimeout(timer);
        }
    }, [isLoaded]);

    return (
        <div style={{ width: '100%', height: '800px', backgroundColor: '#ffffff', position: 'relative' }}>
            {!showPDF && <LoaderContainer><MoonLoader /></LoaderContainer>}
            <iframe
                src={link}
                title="PDF Viewer"
                onLoad={() => setIsLoaded(true)}
                style={{
                    width: '100%',
                    height: '100%',
                    border: 'none',
                    opacity: showPDF ? 1 : 0,
                    transition: 'opacity 0.6s ease-in'
                }}
            />
        </div>
    );
}

const LoaderContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;